import { getShareData } from "../basicInfo/Share";
/**
 * @export
 * @class FixedShare
 * App, MW 공유하기
 */
export default class FixedShare {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_fixed_share';
    this.render();
    this.setEvent();
    this.setFloatingShareBtnTllog();
  }

  setEvent() {
    $('#_showSharePop').on('click', () => {
      this.open();
    });
  }

  setFloatingShareBtnTllog() {
    $('#_showSharePop').attr('tl:area', 'DDSF');
  }

  clearEvent() {
    $('#_showSharePop').off('click');
  }

  open() {
    const htSnsShare = TMON.view_mode === 'app' || window.navigator.share ? getShareData() : null;
    if (TMON.view_mode === 'app') {
			const htAppProps = {
				sRunDatumAppVersion : null,
				aArguments :[
					'other',
					htSnsShare.sTitle,
					htSnsShare.sUrl,
					htSnsShare.sContent,
					htSnsShare.sImage,
					htSnsShare.sUrl
				]
			};
			TMON.app.callApp('webview', 'webviewShare', htAppProps);		
		} else if (window.navigator.share){        
        window.navigator.share({
            title: htSnsShare.sTitle,
            text: htSnsShare.sContent,
            url: htSnsShare.sUrl
        })        
    } else {
      TMON.oApp.oUtil.handleOpenLayer({ welTargetLayer: $(`#${this.sWrapper}`) });
    }
  }

  render() {
    const writeDimension = title =>
      `title:${title}__main_deal_srl:${TMON.htStaticData.sDealNo}__deal_name:${TMON.htStaticData.htDealInfo.titleName}`;
    const isValidAppShare = shareObj => {
      // app이 아닌경우 더보기 기능 navigator share 있는 경우에만 노출
      if (
        TMON.view_mode !== 'app' &&
        shareObj.type === 'other' &&
        !window.navigator.share
      ) {
        return [];
      }

      // app이 아닌경우 인스타그램 미노출 (공유하기 정상동작 하지 않음)
      if (TMON.view_mode !== 'app' && shareObj.type === 'instagram') {
        return [];
      }
      const flag =
        TMON.bMobile ||
        (TMON.view_mode === 'app' &&
          TMON.app[`${'_isValidAppVersion'}`]('5.1.7'))
          ? [shareObj]
          : [];
      return flag;
    };
    const shareArrayHtml = [
      { name: '카카오톡', icon: 'kakao', type: 'kakaotalk', ord: 1 },
      ...isValidAppShare({ name: '밴드', icon: 'band', type: 'band', ord: 8 }),
      { name: '라인', icon: 'line', type: 'line', ord: 4 },
      ...isValidAppShare({
        name: '인스타그램',
        icon: 'insta',
        type: 'instagram',
        ord: 7,
      }),
      { name: 'SMS', icon: 'sms', type: 'sms', ord: 6 },
      { name: 'URL', icon: 'url', type: 'urlcopy', ord: 5 },
      ...isValidAppShare({
        name: '더보기',
        icon: 'more',
        type: 'other',
        ord: 9,
      }),
    ]
      .map(
        item => `
            <li class="icon_list_item">
                <button type="button" data-type=${
                  item.type
                } tl:area="DDSFP" tl:ord=${
          item.ord
        } tl:dimension="${writeDimension(
          item.name
        )}" class="icon_list_button pop_fixed_share ${item.icon}">
                    <span class="icon_list_text">${item.name}</span>
                </button>
            </li>
        `
      )
      .join('');

    const sHtml = `<section id="_fixed_share" class="popup popup_layer popup_share" style="display:none">
              <header class="popup_header">
                  <h3 class="popup_header_title">공유하기</h3>
                  <button type="button" class="popup_header_close" data-role="close" aria-label="팝업닫기">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                          <path fill="#30343B" fillRule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z" />
                      </svg>
                  </button>
              </header>
              <div class="popup_contents">
                  <article class="popup_inner">
                      <div class="icon_list_box">
                          <ul class="icon_list">
                              ${shareArrayHtml}
                          </ul>
                      </div>
                  </article>
              </div>
          </section>`;

    this.welContainer.append(sHtml);
  }
}
